import { Button } from "@/components/ui/button";
import { ArrowRight, Check, Sparkles, MapPin } from "lucide-react";

const HeroSection = () => {
  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center pt-20 pb-24 md:pb-32 overflow-hidden">
      <div className="hero-bg" style={{ backgroundImage: "url('https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/hht6wwln_a6d10632-77a1-4936-a4cb-89e01d811e67.jpeg')" }} />
      <div className="hero-overlay" />
      <div className="absolute top-1/4 right-10 w-72 h-72 bg-emerald-400/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 left-10 w-96 h-96 bg-orange-300/10 rounded-full blur-3xl" />

      <div className="container-custom relative z-10">
        <div className="max-w-2xl">
          <div className="glass rounded-[2rem] p-10 md:p-14">
            {/* Location Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-500/10 border border-emerald-500/20 mb-6">
              <MapPin className="w-4 h-4 text-emerald-600" />
              <span className="text-xs font-bold uppercase tracking-[0.15em] text-emerald-700">
                Krefeld + 25km Umkreis
              </span>
            </div>

            <h1 className="text-[2rem] sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.15] mb-6 font-[Outfit]">
              Dein Thermomix®
              <span className="block mt-1">in <span className="text-gradient">Krefeld.</span></span>
              <span className="block mt-1">Persönlich & Nah.</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-600 mb-8 leading-relaxed max-w-lg">
              Vergiss anonyme Online-Shops. Erlebe den neuen Thermomix® TM7 bei Jennifer Laak – 
              deiner Expertin in Krefeld. Wir bringen Leidenschaft zurück in deine Küche mit 
              persönlicher Beratung, Erlebniskochen und exklusivem Service.
            </p>

            <div className="flex flex-wrap gap-x-6 gap-y-3 mb-10">
              {["Kostenlos & unverbindlich", "Bei dir zuhause", "Persönliche Beratung"].map((benefit, i) => (
                <div key={i} className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-full bg-emerald-500 flex items-center justify-center shadow-sm">
                    <Check className="w-3.5 h-3.5 text-white" strokeWidth={3} />
                  </div>
                  <span className="text-slate-700 font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button onClick={scrollToContact} data-testid="hero-cta-button" className="btn-primary px-10 py-7 text-lg group">
                Jetzt testen
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button
                onClick={() => { const el = document.getElementById("contact"); if (el) el.scrollIntoView({ behavior: "smooth" }); }}
                data-testid="hero-secondary-button"
                className="btn-secondary px-8 py-7 text-lg"
              >
                Beratung anfordern
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2">
        <div className="w-6 h-10 rounded-full border-2 border-slate-300 flex justify-center pt-2 animate-bounce">
          <div className="w-1.5 h-3 bg-slate-400 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
